import type { AppearanceSettings } from '@disenchantment/types';

/** Syncs animation preference to document CSS variables and data flags. */
export function applyAppearanceMotion({ animationsEnabled }: AppearanceSettings): void {
  const root = document.documentElement;
  root.dataset.uiAnimations = animationsEnabled ? '1' : '0';

  if (animationsEnabled) {
    root.style.removeProperty('--motion-duration');
    root.style.removeProperty('--motion-duration-fast');
    root.style.removeProperty('--transition-premium-ms');
  } else {
    root.style.setProperty('--motion-duration', '0ms');
    root.style.setProperty('--motion-duration-fast', '0ms');
    root.style.setProperty('--transition-premium-ms', '0ms');
  }
}
